/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Psm_Single_LineInputs */



/**
* | output |
* | --- |
* | "Single Line" |
*
* @param {Ocr_Psm_Single_LineInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_psm_single_line = /** @type {((inputs?: Ocr_Psm_Single_LineInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Psm_Single_LineInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ligne unique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Einzellinie")
	if (locale === "it") return /** @type {LocalizedString} */ ("Linea singola")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Однолинейный")
	if (locale === "es") return /** @type {LocalizedString} */ ("Línea única")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("单线")
	if (locale === "ja") return /** @type {LocalizedString} */ ("単線")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक लाइन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Linha única")
	return /** @type {LocalizedString} */ ("Single Line")
});